import { onMounted, onUnmounted, ref } from 'vue';

/** Реактивный matchMedia. `const isMobile = useMediaQuery('(max-width: 640px)')`. */
export function useMediaQuery(query: string) {
  const mql = window.matchMedia(query);
  const matches = ref(mql.matches);
  const onChange = (e: MediaQueryListEvent) => { matches.value = e.matches; };
  onMounted(() => mql.addEventListener('change', onChange));
  onUnmounted(() => mql.removeEventListener('change', onChange));
  return matches;
}

export const MOBILE_QUERY = '(max-width: 640px)';
export const TABLET_QUERY = '(max-width: 1024px)';
